module.exports = __webpack_public_path__ + "media/images/v3/b_5-57724e43de650c34cbea21b044629fb4.png";